// extracted by mini-css-extract-plugin
export default {"castList":"aboutCast_castList__9LFqB","castMember":"aboutCast_castMember__wHaPz"};